import request from '@/router/axios'

export function getBamNum(obj) {
    return request({
        url: '/api/screen/zhuye_data',
        method: 'post',
        data: obj
    })
}

export function getzhuye_data(obj) {
    return request({
        url: '/api/screen/getzhuye_data',
        method: 'post',
        data: obj
    })
}

export function getBamDetail(obj) {
    return request({
        url: '/api/screen/zhuye_data_detail',
        method: 'post',
        data: obj
    })
}
